import React, { useState } from 'react';

const Projetos = () => {
  const [activeProject, setActiveProject] = useState(null);

  const toggleProject = (project) => {
    setActiveProject(activeProject === project ? null : project);
  };

  const projects = [
    {
      id: 'nectopoint',
      title: 'NectoPoint - Sistema de Ponto Eletrônico',
      description: (
        <>
          <p className="mb-4">
            Atuei como desenvolvedor frontend neste projeto, que consistiu em criar um sistema completo de gestão de ponto eletrônico. O backend foi construído em Java pela equipe, e eu foquei no desenvolvimento do frontend com React e TypeScript.
          </p>
          <p>
            Minha responsabilidade incluiu a prototipagem e a implementação do site, bem como o desenvolvimento do sistema de solicitações — abrangendo férias, folgas, abonos e ajustes de ponto — integrado à API em Java. Esse trabalho ampliou bastante minhas habilidades em TypeScript e também em Java.
          </p>
        </>
      ),
      details: [
        'Desenvolvi as interfaces utilizando React e TypeScript.',
        'Criei o sistema de solicitações de férias, folgas, abonos e ajustes para os usuários.',
        'Implementei o sistema de aprovação de solicitações voltado para gerentes.',
        'Projetei e desenvolvi barras de navegação personalizadas para diferentes tipos de usuários.',
        'Realizei a integração com a API REST construída em Java pela equipe de backend.',
        'Escrevi códigos bem organizados e detalhados, acompanhados de descrições claras.'
      ],
      technologies: ['React', 'TypeScript', 'Java', 'UI/UX Design', 'Spring Boot'],
      githubLink: 'https://github.com/Equipe-Skyfall/nectopoint',
      softSkills: [
        {
          name: 'Proatividade',
          description: 'No início do projeto, demonstrei dificuldade com a proatividade: demorava para começar as atividades e, por isso, acabava atrasando o grupo todo, já que a parte em que trabalhei era crucial para o projeto. No entanto, com o passar das Sprints, principalmente na Sprint 2, tive um aumento considerável na minha proatividade. Embora o problema não tenha sido solucionado por completo – ainda tenho um pouco de dificuldade nesse quesito –, comparado ao início do projeto, já apresento avanços significativos.'
        },
        {
          name: 'Comunicação',
          description: 'Na comunicação, não só eu, mas todo o grupo enfrentou muitas dificuldades, especialmente na interação entre o frontend e o backend. Esse foi um aspecto em que falhamos coletivamente, e eu, individualmente, também tive minha parcela de falha. Minha participação foi limitada, resumindo-se a presenças em reuniões e em alguns momentos específicos do projeto, o que impediu o desenvolvimento dessa minha habilidade.'
        },
        {
          name: 'Trabalho em Equipe',
          description: 'Assim como na proatividade, o trabalho em equipe também foi um desafio inicial neste projeto. Embora eu tenha atuado com o mesmo grupo do projeto anterior, a mudança de Master exigiu um tempo de adaptação. No entanto, sempre me mantive disponível para oferecer e pedir ajuda quando necessário. A principal dificuldade que enfrentamos foi a falta de explicação no código e problemas com algumas especificidades. Com o tempo, consegui aprimorar esse aspecto, trabalhando ativamente e buscando auxílio dos colegas, o que resultou em uma melhora geral no meu trabalho em equipe, apesar das lacunas pontuais na comunicação.'
        }
      ]
    },
    {
      id: 'prostock',
      title: 'ProStock - Sistema de Gestão de Estoque',
      description: (
        <>
          <p className="mb-4">
            Trabalhei como desenvolvedor full stack neste projeto, com destaque especial no frontend. Fui responsável por criar a página de geração de relatórios, desenvolver o sistema de histórico com tabelas complexas e implementar toda a interface de configuração de usuários. Além disso, estabeleci e padronizei toda a estilização do sistema, criando um design system que facilitou muito o trabalho da equipe.
          </p>
          <p>
            Essa padronização foi um dos diferenciais do projeto — criei componentes reutilizáveis e guidelines de estilo que tornaram o desenvolvimento mais ágil e consistente. Acabei me tornando referência da equipe quando o assunto era interface e experiência do usuário, sempre buscando entregar algo além do esperado.
          </p>
        </>
      ),
      details: [
        'Desenvolvi a página completa de geração de relatórios com filtros avançados e exportação de dados.',
        'Criei o sistema de histórico utilizando tabelas dinâmicas e responsivas.',
        'Implementei toda a interface de configuração de usuários com gestão de permissões.',
        'Estabeleci a padronização completa da estilização do sistema (design system).',
        'Desenvolvi componentes reutilizáveis que aceleraram o desenvolvimento da equipe.',
        'Trabalhei tanto no frontend (React/TypeScript) quanto no backend (Prisma/JavaScript).',
        'Otimizei a performance das tabelas para lidar com grandes volumes de dados.'
      ],
      technologies: ['React', 'TypeScript', 'Prisma', 'REST API'],
      githubLink: 'https://github.com/EquipeSkyfall/API_2Semestre',
      softSkills: [
        {
          name: 'Destaque e Protagonismo',
          description: 'Me tornei referência da equipe em frontend e UX, sempre entregando além do esperado. A padronização que criei foi adotada por todos e virou um diferencial do projeto, mostrando minha capacidade de impactar positivamente o time todo.'
        },
        {
          name: 'Atenção aos Detalhes',
          description: 'A criação do design system exigiu muita atenção aos detalhes — espaçamentos, cores, tipografia, componentes. Cada decisão foi pensada para criar uma experiência consistente e profissional em todas as telas do sistema.'
        },
        {
          name: 'Full Stack Mindset',
          description: 'Mesmo com destaque no frontend, não me limitei a isso. Trabalhei ativamente no backend também, entendendo a aplicação de ponta a ponta. Essa visão completa me ajudou a criar soluções mais integradas e eficientes.'
        }
      ]
    },
    {
      id: 'estufa',
      title: 'Smart Farming - Monitoramento de Estufas',
      description: (
        <>
          <p className="mb-4">
            Neste projeto, assumi o papel de Scrum Master e contribuí ativamente tanto no backend quanto no frontend. Trabalhei com Python no desenvolvimento do backend e implementei a containerização da aplicação usando Docker. Uma das minhas maiores contribuições foi criar todos os gráficos do sistema do zero, desenvolvidos inteiramente em JavaScript puro.
          </p>
          <p>
            Foi um desafio interessante porque tive que equilibrar as responsabilidades de gestão da equipe com o desenvolvimento técnico. A parte mais gratificante foi transformar dados complexos de sensores em visualizações intuitivas que realmente ajudassem os usuários a entender o que estava acontecendo nas estufas.
          </p>
        </>
      ),
      details: [
        'Atuei como Scrum Master, coordenando sprints e facilitando a comunicação da equipe.',
        'Desenvolvi o backend utilizando Python, implementando APIs e lógica de negócio.',
        'Contribuí no desenvolvimento frontend com foco em interfaces responsivas.',
        'Criei todos os gráficos de visualização de dados utilizando JavaScript puro.',
        'Implementei a containerização completa da aplicação com Docker.',
        'Integrei sensores e tratei os dados coletados para exibição em tempo real.',
        'Desenvolvi sistema de alertas automatizados baseado em thresholds configuráveis.'
      ],
      technologies: ['JavaScript', 'Python', 'Docker', 'IoT', 'UI/UX Design', 'Data Visualization', 'Scrum'],
      githubLink: 'https://github.com/CyberScrums/Projeto-Smart-Farming',
      softSkills: [
        {
          name: 'Liderança como Scrum Master',
          description: 'Coordenei a equipe durante todo o projeto, facilitando dailies, plannings e retrospectivas. Ajudei a remover impedimentos e mantive o time focado nas metas de cada sprint, equilibrando isso com minhas próprias entregas técnicas.'
        },
        {
          name: 'Versatilidade Técnica',
          description: 'Transitei entre diferentes áreas do projeto - backend em Python, frontend, containerização com Docker e visualização de dados com JavaScript. Essa flexibilidade foi essencial para cobrir gaps da equipe e manter o projeto em movimento.'
        },
        {
          name: 'Criatividade na Visualização de Dados',
          description: 'Desenvolvi gráficos customizados do zero em JavaScript puro, sem depender de bibliotecas prontas. Isso me deu controle total sobre como os dados dos sensores eram apresentados, resultando em dashboards realmente úteis para os usuários finais.'
        }
      ]
    }
    ,
    {
      id: 'skytrack',
      title: 'SkyTrack - Sistema de Coleta Meteorológica',
      description: (
        <>
          <p className="mb-4">
            Neste projeto atuei como Product Owner em parceria com a Tecsus, uma empresa real que nos contratou para desenvolver um Sistema de Coleta de Dados Meteorológico em Tempo Real focado na prevenção de riscos e desastres naturais. Foi minha responsabilidade fazer a ponte entre o cliente e a equipe de desenvolvimento, garantindo que todos entendessem perfeitamente o que precisava ser construído.
          </p>
          <p>
            Desenvolvi toda a arquitetura do sistema e o modelo de entidade e relacionamento do banco de dados. Implementei práticas de DevOps como Requirement Tracking, mantendo a rastreabilidade de ponta a ponta durante todo o projeto. Organizei o product backlog e os sprint backlogs para 3 sprints de desenvolvimento, criando um roadmap sólido que nos levou a entregar um MVP de excelente qualidade para o cliente.
          </p>
        </>
      ),
      details: [
        'Atuei como Product Owner em projeto com a empresa Tecsus',
        'Desenvolvi a arquitetura completa do sistema e o modelo de entidade e relacionamento.',
        'Implementei práticas de DevOps com foco em Requirement Tracking de ponta a ponta.',
        'Mantive contato frequente com o cliente para esclarecer dúvidas e alinhar expectativas.',
        'Organizei product backlog e sprint backlogs para 3 sprints de desenvolvimento.',
        'Criei roadmap detalhado baseado nos requisitos do cliente e nas entregas planejadas.',
        'Geri o backlog priorizando funcionalidades para entregar um MVP de alto valor.',
        'Facilitei a comunicação entre stakeholders e equipe de desenvolvimento.'  
      ],
      technologies: ['Product Owner', 'DevOps', 'Req Tracking', 'Jira', 'Scrum', 'Arquitetura de Software', 'Modelagem de Dados', 'Gestão de Backlog'],
      githubLink: 'https://github.com/Equipe-Skyfall/skytrack',
      softSkills: [
        {
          name: 'Visão de Produto',
          description: 'Como PO, traduzi as necessidades da Tecsus em uma visão clara de produto. Priorizei funcionalidades com base no valor de negócio e no impacto para prevenção de desastres, garantindo que cada sprint entregasse valor tangível.'
        },
        {
          name: 'Comunicação com Stakeholders',
          description: 'Mantive contato constante com o cliente para esclarecer dúvidas e alinhar expectativas. Essa ponte entre negócio e tecnologia foi essencial para eliminar ambiguidades e garantir que a equipe sempre soubesse exatamente o que construir.'
        },
        {
          name: 'Pensamento Arquitetural',
          description: 'Desenvolvi a arquitetura do sistema e o modelo de dados considerando escalabilidade, integração com múltiplas fontes de sensores e requisitos de tempo real. Essa visão técnica foi fundamental para guiar as decisões de implementação da equipe.'
        }
      ]
    },
    {
      id: 'mljob',
      title: 'MLJobTrend - Análise de Mercado de Machine Learning',
      description: (
        <>
          <p className="mb-4">
            Desenvolvi este projeto pessoal para analisar o crescimento exponencial das vagas de Machine Learning no mercado. Utilizei um dataset do Kaggle chamado "Machine Learning Job Postings in the US" que contém informações detalhadas sobre vagas, empresas e períodos, permitindo visualizar tendências concretas ao longo do tempo.
          </p>
          <p>
            Com Python, Pandas e Matplotlib, tratei e visualizei esses dados criando gráficos intuitivos que revelam insights valiosos: desde a evolução da demanda por Engenheiros de ML comparada com áreas correlatas, até quais empresas lideram a contratação nessa área. O projeto mostra que ML não apenas cresce, mas está se tornando estratégico como uma nova "Corrida à Lua" tecnológica.
          </p>
        </>
      ),
      details: [
        'Realizei análise exploratória de dados de vagas de Machine Learning nos Estados Unidos.',
        'Utilizei Python com Pandas para tratamento e manipulação de grandes volumes de dados.',
        'Criei visualizações com Matplotlib mostrando evolução temporal das vagas de ML.',
        'Desenvolvi gráfico comparativo entre Engenheiro de ML e áreas correlatas.',
        'Implementei análise das empresas que mais contratam profissionais de Machine Learning.',
        'Identifiquei tendências e padrões de crescimento no primeiro semestre de 2025.',
        'Transformei dados brutos do Kaggle em insights estratégicos sobre o mercado de trabalho.'
      ],
      technologies: ['Python', 'Pandas', 'Matplotlib', 'Data Analysis', 'Data Visualization', 'Machine Learning', 'Kaggle'],
      githubLink: 'https://github.com/DuuhZero/Machine-Learning-Job-Trend',
      softSkills: [
        {
          name: 'Pensamento Analítico',
          description: 'Transformei uma observação empírica sobre o crescimento de vagas em ML em uma análise baseada em dados concretos. Utilizei um dataset do Kaggle para validar hipóteses e extrair insights reais sobre tendências de mercado, demonstrando capacidade de pensar com base em evidências.'
        },
        {
          name: 'Comunicação de Dados',
          description: 'Criei visualizações claras e intuitivas que contam uma história sobre o mercado de ML. Os gráficos não apenas mostram números, mas revelam narrativas — como o "boom" do primeiro semestre de 2025 e a disparidade entre líderes como TikTok e Meta, tornando dados complexos acessíveis.'
        },
        {
          name: 'Visão de Mercado',
          description: 'Identifiquei que empresas líderes como Amazon, Google e Meta estão investindo pesadamente em ML, tratando IA como elemento estratégico. Essa análise mostra capacidade de conectar dados técnicos com tendências de negócio e entender o mercado como uma "Corrida à Lua" pela inovação.'
        }
      ]
    },
    {
      id: 'fuelnavigator',
      title: 'Fuel Navigator - App de Gestão de Consumo',
      description: (
        <>
          <p className="mb-4">
            Desenvolvi um aplicativo mobile completo para Android que fornece informações precisas sobre consumo de combustível em trajetos. O app permite aos usuários gerenciar dados pessoais e de veículos, calcular estimativas de consumo e gasto baseadas em rotas reais, além de gerar relatórios detalhados de uso.
          </p>
          <p>
            Implementei funcionalidades como CRUD completo de usuários e veículos, sistema de navegação com cálculo automático de consumo baseado nas características do veículo, histórico de rotas, geração de relatórios mensais, e suporte offline com sincronização em nuvem. A aplicação conta com interface responsiva, temas claro/escuro e autenticação segura.
          </p>
        </>
      ),
      details: [
        'Desenvolvi CRUD completo para gerenciamento de usuários e veículos.',
        'Implementei sistema de navegação com busca e salvamento de rotas (online e offline).',
        'Criei algoritmo de cálculo de consumo de combustível baseado em distância e características do veículo.',
        'Desenvolvi sistema de histórico de rotas recentemente utilizadas.',
        'Implementei geração de relatórios semanais/mensais sobre consumo com exportação em PDF.',
        'Configurei persistência de dados com backup local e sincronização em nuvem.',
        'Desenvolvi interface responsiva com suporte a temas claro e escuro.',
        'Implementei autenticação segura com criptografia básica de dados.'
      ],
      technologies: ['Android', 'Java', 'Vercel', 'MongoDB', 'OpenRouteService API', 'React Native', 'Material Design'],
      githubLink: 'https://github.com/DuuhZero/Fuel-Navigator',
      softSkills: [
        {
          name: 'Planejamento e Organização',
          description: 'Estruturei o projeto seguindo metodologia ágil com product backlog completo, dividindo 10 user stories em 3 sprints. Priorizei funcionalidades críticas (CRUD, navegação, cálculos) na Sprint 1, features complementares (salvamento, relatórios) na Sprint 2, e refinamentos (UI/UX, autenticação) na Sprint 3.'
        },
        {
          name: 'Foco na Experiência do Usuário',
          description: 'Desenvolvi interface simples e intuitiva pensando em motoristas que precisam de informações rápidas. Implementei temas claro/escuro para diferentes condições de uso, suporte offline para rotas sem internet, e relatórios visuais que transformam dados brutos em insights acionáveis.'
        },
        {
          name: 'Solução de Problemas Técnicos',
          description: 'Enfrentei desafios como sincronização online/offline, cálculos precisos de consumo variando por tipo de veículo, e geração eficiente de relatórios. Cada funcionalidade exigiu pesquisa, testes e refinamento para entregar uma aplicação confiável e performática para usuários reais.'
        }
      ]
    },
    {
      id: 'llmbusinessrules',
      title: 'LLM Business Rules - Tradutor de Regras para Código',
      description: (
        <>
          <p className="mb-4">
            Desenvolvi um agente inteligente capaz de interpretar regras de negócio em linguagem natural e convertê-las automaticamente em código Python funcional. Utilizei o Ollama com o modelo Mistral:latest para criar um tradutor que transforma requisitos de negócio comum em código executável.
          </p>
          <p>
            O projeto incluiu todo o treinamento da IA com arquivos de conversão e prompts customizados. Implementei uma interface de chat com Gradio UI para facilitar a interação, permitindo que usuários insiram regras como "Se o valor da compra for superior a R$ 200, aplicar desconto de 10%" e recebam automaticamente funções Python prontas para uso. Focado inicialmente em domínios específicos como cálculo de descontos, políticas de frete e impostos básicos.
          </p>
        </>
      ),
      details: [
        'Implementei integração completa com Ollama utilizando o modelo Mistral:latest.',
        'Desenvolvi sistema de treinamento da IA com arquivos de conversão e prompts especializados.',
        'Criei interface de chat interativa usando Gradio UI para facilitar a conversão de regras.',
        'Desenvolvi pipeline de processamento de linguagem natural para interpretar regras de negócio.',
        'Implementei geração automática de código Python funcional a partir de texto.',
        'Criei conjunto de exemplos e validações para domínios específicos (descontos, frete, impostos).',
        'Desenvolvi sistema de testes para garantir que o código gerado seja executável e correto.',
        'Documentei todo o processo de treinamento e uso da ferramenta.'
      ],
      technologies: ['Python', 'Ollama', 'Mistral AI', 'Gradio', 'LLM', 'NLP', 'Machine Learning', 'Prompt Engineering'],
      githubLink: 'https://github.com/DuuhZero/llm-business-rules',
      softSkills: [
        {
          name: 'Inovação e Experimentação',
          description: 'Explorei tecnologias emergentes de LLM (Large Language Models) para resolver um problema real: tradução de requisitos de negócio em código. Experimentei com Ollama e Mistral AI, testando diferentes abordagens de prompt engineering até encontrar a melhor forma de treinar o modelo para gerar código Python funcional.'
        },
        {
          name: 'Aprendizado Autodidata',
          description: 'Mergulhei no universo de LLMs, Ollama e Gradio por conta própria. Estudei processamento de linguagem natural, técnicas de prompt engineering e fine-tuning de modelos. Todo o treinamento da IA foi feito através de pesquisa, testes e refinamento contínuo até alcançar resultados satisfatórios.'
        },
        {
          name: 'Visão Prática de Automação',
          description: 'Identifiquei uma oportunidade de automatizar a conversão de regras de negócio em código — um trabalho repetitivo e propenso a erros quando feito manualmente. Desenvolvi uma solução que não apenas economiza tempo, mas também padroniza a geração de código para domínios específicos como descontos, frete e impostos.'
        }
      ]
    }
  
  ];

  return (
    <section className="py-20 px-4 sm:px-6 max-w-6xl mx-auto bg-gradient-to-br from-gray-50 to-white min-h-screen">
      <div className="text-center mb-12 sm:mb-16">
        <div className="relative inline-block group">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold gradient-text mb-4">
            Meus Projetos
          </h1>
        </div>
        <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4 leading-relaxed">
          Trabalhos em que combinei habilidades técnicas e visão de produto para entregar soluções completas
        </p>
      </div>

      <div className="space-y-6 sm:space-y-8 px-2 sm:px-0">
        {projects.map((project) => (
          <div
            key={project.id}
            className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden transition-all duration-300 hover:border-red-500 hover:shadow-xl"
          >
            <div className="p-6 sm:p-8">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">
                <div className="flex-1">
                  <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-red-600 mb-3">{project.title}</h2>

                  <div className="flex flex-wrap gap-2 mb-5">
                    {project.technologies.map((tech, index) => (
                      <span
                        key={index}
                        className="text-xs sm:text-sm px-3 py-1.5 bg-red-50 border border-red-200 rounded-full text-red-700 font-medium"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  <div className="text-gray-700 mb-4 space-y-3 text-sm sm:text-base leading-relaxed">
                    {project.description}
                  </div>

                  {activeProject === project.id && (
                    <div className="mt-6 space-y-6">
                      <div>
                        <h3 className="text-lg font-bold text-gray-900 mb-4">Contribuições Pessoais</h3>
                        <div className="space-y-2 pl-4 border-l-4 border-red-500 text-sm sm:text-base">
                          {project.details.map((item, index) => (
                            <div key={index} className="text-gray-600">
                              <p className="mb-2">• {item}</p>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div>
                        <h3 className="text-lg font-bold text-gray-900 mb-4">Soft Skills Demonstradas</h3>
                        <div className="space-y-4">
                          {project.softSkills.map((skill, index) => (
                            <div key={index} className="bg-gradient-to-r from-red-50 to-white p-5 rounded-xl border border-red-200">
                              <div className="flex justify-between items-center mb-2">
                                <h4 className="font-bold text-red-600">{skill.name}</h4>
                              </div>
                              <p className="text-gray-600 text-sm leading-relaxed">{skill.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex flex-col space-y-3 sm:space-y-4 w-full sm:w-48">
                  <button
                    onClick={() => toggleProject(project.id)}
                    className="px-4 sm:px-6 py-2.5 sm:py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm sm:text-base"
                  >
                    {activeProject === project.id ? 'Mostrar Menos' : 'Detalhes'}
                  </button>

                  <a
                    href={project.githubLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 sm:px-6 py-2.5 sm:py-3 border-2 border-red-600 text-red-600 rounded-lg font-semibold hover:bg-red-50 transition-all duration-300 text-center text-sm sm:text-base"
                  >
                    Ver no GitHub
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projetos;